
import verification from "@/components/verificationCode/verification.vue";
import emojiPicker from "@/components/emojiPicker/emojiPicker.vue";
import atBox from "@/components/at/atBox.vue";
import { trackLoginImpression } from '@/plugins/hwtag/events'
import { notifyApiErrorMsg } from '@/utils/blockUser'
export default {
  name: "comment",
  props: {
    id: {
      type: Number,
    },
    relationType: {
      type: Number,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    sourceData: {
      type: Object,
      default: {},
    },
  }, //relationType 1作品 3资讯教程 4帖子
  components: { emojiPicker, atBox, verification },
  data() {
    return {
      // at:false,
      asyncSource: [],
      loading: false,
      comments: "", //评论内容
      value: "",
      selectionStart: "", //光标位置
      // atLoading: true,
      userAts: [],
      captchaCode: "",
      backParams: {},
      isButtonDisabled: true,
      commentPage: 1,
      commentPageSize: 50,
      commentHasMore: true,
      commentLoadingMore: false,
    };
  },
  mounted() {
    if (!this.disabled) {
      this.resetCommentPagination();
      this.getCommentLists();
      window.addEventListener("scroll", this.handleCommentScroll, { passive: true });
    }

    console.log(this.sourceData, "sourceDatasourceDatasourceDatasourceDatasourceData");
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleCommentScroll);
  },

  computed: {
    currentUid() {
      return this.$store.state.userInfo?.userInfo?.uid || "";
    },
    complaintSource() {
      // console.log(this.$route, 'urlurlurl')
      //1作品图片2作品视频3资讯4课程5帖子图片6帖子视频7作品评论8帖子评论9课程评论
      switch (this.$route.name) {
        case "discussion-id":
          return 8;
        case "gallery-id":
          return 7;
        case "tutorial-details":
          return 9;
      }
    },
    complaintSourceComment() {
      //1作品评论 3资讯教程 4帖子
      switch (this.$route.name) {
        case "discussion-id":
          return 4;
        case "gallery-id":
          return 1;
        case "tutorial-details":
          return 3;
      }
    },
  },
  watch: {
    comments(newVal) {
      this.isButtonDisabled = !newVal; // 如果输入框不为空，则不禁用按钮
    },
  },
  methods: {
    getLoginChannel() {
      return this.$route.name === 'discussion-id' ? '讨论帖互动' : '发布作品';
    },
    openLoginWithSource(elementTypeName, clickName, loginChannel) {
      const useNewLogin = this.$store.state.siteConfig && this.$store.state.siteConfig.DialogPassportSwitch == '1';
      if (useNewLogin) {
        this.$store.commit('OPEN_AUTH_MODAL', {
          tab: 'login',
          redirectToUserCenter: false,
          source: { elementTypeName, clickName, loginChannel },
        });
      } else {
        this.$jumpTerminus(1);
      }
    },
    triggerGlobalLogin() {
      trackLoginImpression('点击', '评论', 'login', {}, this.getLoginChannel());
      this.openLoginWithSource('评论', 'login', this.getLoginChannel());
    },
    resetCommentPagination() {
      this.commentPage = 1;
      this.commentHasMore = true;
    },
    handleCommentScroll() {
      if (this.loading || !this.commentHasMore || this.disabled) {
        return;
      }

      const wrapper = this.$refs.commentWrapper;
      if (!wrapper) {
        return;
      }

      const rect = wrapper.getBoundingClientRect();
      const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
      if (rect.bottom <= viewportHeight + 80) {
        this.getCommentLists(this.commentPage + 1, true);
      }
    },
    normalizeCommentItem(item) {
      item.isReply = false;
      item.comments = "";
      if (Array.isArray(item.appoint_uid) && item.content) {
        // 正文里的 @用户名换成主页链接。昵称可能自带 @，也可能不带
        item.appoint_uid.forEach((it) => {
          const mention = this.buildMentionToken(it && it.nickname);
          if (!mention || !item.content.includes(mention)) {
            return;
          }
          item.content = item.content.replaceAll(
            mention,
            `<a href="/user/${it.uid}" style="color:#f9874f">${mention}</a>`
          );
        });
      }
      if (!Array.isArray(item.commentList_map)) {
        item.commentList_map = [];
      }
      item.commentList_map.forEach((it) => {
        it.isReply = false;
        it.comments = "";
      });
      return item;
    },
    /**
     * 把接口返回的昵称收成正文里的 @用户名。
     * @param {string} nickname 可能是 Siah，也可能是 @Siah
     * @returns {string} 空昵称返回空字符串
     */
    buildMentionToken(nickname) {
      const name = String(nickname || "").trim().replace(/^@+/, "");
      return name ? `@${name}` : "";
    },
    async getCommentLists(page = 1, append = false) {
      //获取评论列表
      if (this.loading) {
        return;
      }

      if (!append) {
        this.resetCommentPagination();
      }
      this.commentLoadingMore = append;
      this.loading = true;
      try {
        let res = await this.$global.commentLists({
          id: this.id,
          relationType: this.relationType,
          parent_id: 0,
          page,
          pageSize: this.commentPageSize,
        });

        if (res.code == 200) {
          const source = res.data || {};
          const commentList = source.commentList || {};
          const nextList = Array.isArray(commentList.data)
            ? commentList.data.map((item) => this.normalizeCommentItem(item))
            : [];

          if (append && this.asyncSource?.commentList?.data) {
            const oldList = this.asyncSource.commentList.data;
            const oldIds = new Set(oldList.map((item) => item.id));
            source.commentList = {
              ...commentList,
              data: oldList.concat(nextList.filter((item) => !oldIds.has(item.id))),
            };
          } else {
            source.commentList = {
              ...commentList,
              data: nextList,
            };
          }

          const loadedCount = source.commentList.data.length;
          const total = Number(commentList.total || source.comment_find_count || 0);
          this.commentPage = page;
          this.commentHasMore = nextList.length >= this.commentPageSize && (!total || loadedCount < total);
          this.asyncSource = source;
        }
      } finally {
        this.loading = false;
        this.commentLoadingMore = false;
      }
      // console.log(this.asyncSource, ' this.asyncSource')
    },
    beforeSendComment(comments, parent_id, reply_uid, item,parent_item) {
      this.sendComment(comments, parent_id, reply_uid, item,parent_item);
    },
    triggerMethod() {
      this.sendComment(
        this.backParams.comments,
        this.backParams.parent_id,
        this.backParams.reply_uid,
        this.backParams.item,
        this.backParams.parent_item,
      );
    },
    async sendComment(comments, parent_id, reply_uid, item,parent_item) {
        console.log(item,'itemmmmmmmmmmmmmmmmmmmmmmmmmmmmm')
        console.log(parent_item,'parent_itemparent_itemparent_item')
      let res = await this.$global.commentAdd({
        id: this.id,
        relationType: this.relationType,
        content: comments,
        is_anonymous: 0,
        parent_id: parent_id,
        appoint_uid: "",
        reply_uid: reply_uid,
        appoint_uid: JSON.stringify(this.userAts),
        check_str: this.captchaCode,
      });
      const VERIFY_COMMENT = "verifyComment";

      if (res.code == 200) {
        this.$refs.verification.changeVisible(false);
        this.getCommentLists(1, false);
        this.comments = "";

        this.$refs.verification.captchaCode = "";
        let obj = this.$cookies.get(VERIFY_COMMENT) || {};
        obj[this.$route.path] = (obj[this.$route.path] || 0) + 1;
        this.$cookies.set(VERIFY_COMMENT, JSON.stringify(obj));
        if (item == "") {
          /** hwtag埋点-内容评论*/
          //relationType 1作品 3资讯教程 4帖子
          this.$track("content_commented", {
            content_id: this.relationType == 3?this.sourceData.collection_type_id:this.sourceData.id,
            content_type:
              this.relationType == 1
                ? "gallery"
                : this.relationType == 3
                ? "courses"
                : "discussion",
            author_id: this.sourceData.uid || "00001",
            author:   this.sourceData.nickname || "xppen",
            comment_id: res.data.commentId,
            current_comments: this.relationType=='3'?this.sourceData.video_find.comment_num:this.sourceData.comment_num ,
          });
        }else{

          this.$track("comment_replied", {
            content_id: this.relationType == 3?this.sourceData.collection_type_id:this.sourceData.id,
            content_type:
              this.relationType == 1
                ? "gallery"
                : this.relationType == 3
                ? "courses"
                : "discussion",
            author_id: this.sourceData.uid || "00001",
            author: this.sourceData.nickname || "xppen",
            comment_user_id: item.userInfo.uid,
            comment_user: item.userInfo.nickname,
            comment_id: item.id,
            comment_current_reply: item.hasOwnProperty("commentList_count")?item.commentList_count: parent_item.commentList_count,
          });
        }
      } else if (res.code == 509) {
        this.$refs.verification.changeVisible(true);
        this.$refs.verification.getCaptcha();
        this.backParams = {
          comments,
          parent_id,
          reply_uid,
          item,
          parent_item
        };
      } else {
        this.$refs.verification.getCaptcha();
        this.$refs.verification.captchaCode = "";
        notifyApiErrorMsg(res, this, this.$t('page.ERROR'))
      }
      this.captchaCode = "";
    },
    replyOperation(item) {
      if (!this.$store.state.isLogin) {
        trackLoginImpression('点击', '评论', 'reply', {}, this.getLoginChannel());
        this.openLoginWithSource('评论', 'reply', this.getLoginChannel());
        return;
      }
      item.isReply = !item.isReply;
      item.comments = '';
    },
    async likeOperation(item) {
      if (!this.$store.state.isLogin) {
        trackLoginImpression('点击', '评论', 'like', {}, this.getLoginChannel());
        this.openLoginWithSource('评论', 'like', this.getLoginChannel());
        return;
      }
      //点赞 取消点赞
      // type7作品评论点赞、取消点赞 8 教程咨询评论点赞、取消点赞 22 帖子评论点赞 取消点赞

      let res = await this.$global.likeaction({
        relation_id: item.id,
        type:
          this.relationType == 1
            ? "7"
            : this.relationType == 3
            ? "8"
            : this.relationType == 4
            ? "22"
            : "",
      });
      if (res.code == 200) {
        this.getCommentLists(1, false);
        if (item.hasLike == 0) {
          /** hwtag埋点-点赞评论*/
          this.$track("comment_liked", {
            content_id:  this.relationType == 3?this.sourceData.collection_type_id:this.sourceData.id,
            content_type:
              this.relationType == 1
                ? "gallery"
                : this.relationType == 3
                ? "courses"
                : "discussion",
            author_id: this.sourceData.uid || "00001",
            author: this.sourceData.nickname || "xppen",
            comment_user_id: item.userInfo.uid,
            comment_user: item.userInfo.nickname,
            comment_id: item.id,
            comment_current_like: item.comment_like,
          });
        }
      } else {
        notifyApiErrorMsg(res, this)
      }
    },
    async deleteComment(relationType, comment_id) {
      //删除评论
      //id 是 作品评论 资讯教程 帖子 ID
      //relationType 1作品评论 3资讯教程 4帖子
      //评论对应的ID
      console.log(relationType, comment_id);
      let res = await this.$global.commentDel({
        relationType,
        id: relationType == 3 ? this.$route.query.collection_id : this.$route.params.id,
        comment_id,
      });
      if (res.code == 200) {
        this.getCommentLists(1, false)
        return
      }
      notifyApiErrorMsg(res, this, this.$t('page.ERROR'))
    },
    emoji_click(value, index, idx) {
      //index子评论索引 idx子评论回复索引
      index == undefined && idx == undefined
        ? (this.comments += value)
        : index != undefined && idx == undefined
        ? (this.asyncSource.commentList.data[index].comments += value)
        : (this.asyncSource.commentList.data[index].commentList_map[
            idx
          ].comments += value);
    },
    enterFocus(e) {
      // console.log(e.srcElement.selectionStart);
      this.selectionStart = e.srcElement.selectionStart;
    },
    // keydown触发事件(按下键盘时候触发)
    enterEv(e) {
      const { keyCode, code } = e;
    },
    // input变化
    enterInput(e) {
      let that = this;
      this.userAts.forEach(function (item, i) {
        console.log(
          that.comments,
          that.comments.includes("@" + item.nickname),
          item,
          "循环"
        );
        if (!that.comments.includes("@" + item.nickname)) {
          that.userAts.splice(i, 1);
        }
      });
      console.log(this.userAts);
    },
    getAt(atValue, userAt, selectionVal) {
      this.comments = atValue;
      this.userAts = userAt;
      this.selectionStart = selectionVal;
    },
  },
};
